/**
 * ImageLazyLoad.ts
 */

import LazyLoad from 'vanilla-lazyload';

const ImageLazyLoad = (() => {

    let options = {
        initElem: document.getElementsByClassName('js-lazyload')
    }

    function init() {

        if(options.initElem.length) {

            initLazy();

            if(EWDS_DEBUG) {
                console.log('[DEBUG] ImageLazyLoad : initialized');
            }
        }

    }

    function initLazy() {
        
        let myLazyLoad = new LazyLoad();
        
    }

    return {
        init: init
    };

})();

export default ImageLazyLoad;